import React from 'react'
import {observer} from 'mobx-react'
import {LocationIcon, PhoneIcon} from '../../../components/icons'
import {useCustomerStore} from '../../../store/hooks/useStore'
import {Box, Button, Flex, Stack, Text} from '../../../vanilla'
import {OrderAddress} from '../../../types/store/basket'

interface YourDeliverySelectedAddressProps {
  onNewAddressClick: () => void
  onEditAddressClick: () => void
  selectedAddress?: OrderAddress
}

export const YourDeliverySelectedAddress = observer((props: YourDeliverySelectedAddressProps) => {
  const {onNewAddressClick, onEditAddressClick, selectedAddress} = props
  const {addresses} = useCustomerStore()
  const {fullName, title, addressId, phone, address1, address2, stateCode, city, postalCode} = (selectedAddress || {}) as OrderAddress

  const showAddButton = (addresses || []).length <= 1
  function displayAddress() {
    return [address1, address2,stateCode, city, postalCode].filter(Boolean).join(', ')
  }


  return (
    <Box display="grid" gridTemplateColumns={['1x', '12x']} gridColumnGap="12px" gridRowGap="16px" data-cs-mask="">
      <Stack gridColumn={['1', 'span 7']} position="relative" paddingLeft="20px" data-cs-mask="">
        <LocationIcon
          position="absolute"
          style={{top: '-2px', left: '-6px'}}
          width="20px"
          height="20px"
        />
        <Stack spacing="4px" data-cs-mask="">
          {fullName && (
            <Text lineHeight="shorter" variant="text4" data-cs-mask="">
              {fullName}
            </Text>
          )}
          {title && (
            <Text lineHeight="shorter" variant="text4" data-cs-mask="">
              {title}
            </Text>
          )}
          {addressId && (
            <Text lineHeight="shorter" variant="text4" data-cs-mask="">
              {addressId}
            </Text>
          )}
          <Text lineHeight="shorter" variant="text4" data-cs-mask="">
            {displayAddress()}
          </Text>
        </Stack>
        <Flex gap="8px">
          <Button
            variant="link"
            onClick={() => onEditAddressClick()}
            textDecoration="underline"
            style={{width: 'fit-content', height: 'fit-content'}}
          >
            Edit this address
          </Button>
          {showAddButton ? (
            <>
              <Box borderLeft="1px" borderColor="gray200" marginX="2px" height="20px" />
              <Button
                variant="link"
                onClick={() => onNewAddressClick()}
                textDecoration="underline"
                style={{width: 'fit-content', height: 'fit-content'}}
              >
                Add new address
              </Button>
            </>
          ) : null}
        </Flex>
      </Stack>

      <Stack gridColumn={['1', 'span 5']} paddingLeft="20px" position="relative" data-cs-mask="">
        <PhoneIcon
          position="absolute"
          style={{top: '-2px', left: '-6px', color: '#bebebe'}}
          width="20px"
          height="20px"
        />
        <Text lineHeight="shorter" variant="text4" data-cs-mask="">
          {phone || ''}
        </Text>
        <Button
          variant="link"
          onClick={() => onEditAddressClick()}
          textDecoration="underline"
          style={{width: 'fit-content', height: 'fit-content'}}
        >
          Change this number
        </Button>
      </Stack>
    </Box>
  )
})
